// extracted by mini-css-extract-plugin
export default {"error":"cEvoP22oMS7gyPqS9RCf","pulse":"_2NLSKgJKAJHpUSEDcpV"};